import React from 'react';
import * as Styled from './OCardLayeredStandard.styles';
import {
  OCardLayeredStandardProps,
  OCardLayeredStandardCTAStyle,
  OCardLayeredStandardAspectRatio,
} from './OCardLayeredStandard.types';
import { AImage } from '../../atoms/AImage/index';
import { AScrimGradient } from '../../atoms/AScrimGradient/index';
import { MTextBlockBasic } from '../../molecules/MTextBlockBasic/index';
import { AIcon } from '../../atoms/AIcon/index';
import { MTag } from '../../molecules/MTag/index';
import { MButton, MButtonType, MButtonSize, MButtonIconPlacement } from '../../molecules/MButton/index';
import { ALabelSize } from '../../atoms/ALabel/ALabel.types';

export const OCardLayeredStandard: React.FC<OCardLayeredStandardProps> = ({
  ctaLink,
  aspectRatio = OCardLayeredStandardAspectRatio.WIDE_16_9,
  cTAStyle = OCardLayeredStandardCTAStyle.Button,
  aImage,
  aScrimGradient,
  mTextBlockBasic,
  aIcon,
  mTag,
  mButton,
  mButtonIcon,
  className,
}) => {
  const showButton1 = cTAStyle === OCardLayeredStandardCTAStyle.Button && mButton;
  const showIconButton = cTAStyle === OCardLayeredStandardCTAStyle.Arrow && mButtonIcon;

  const handleCardClick = () => {
    if (ctaLink && cTAStyle === OCardLayeredStandardCTAStyle.Arrow) {
      window.location.href = ctaLink;
    }
  };
  console.log(showButton1, 'Somesh');
  return (
    <Styled.Wrapper
      className={`${className || ''} inverse`}
      aspectRatio={aspectRatio}
      isClickable={cTAStyle === OCardLayeredStandardCTAStyle.Arrow}
      onClick={cTAStyle === OCardLayeredStandardCTAStyle.Arrow ? handleCardClick : undefined}
    >
      <Styled.ImageContainer aspectRatio={aspectRatio}>
        {aImage && (
          <AImage
            src={aImage.image?.assetPath}
            alt={aImage.image?.altText || ''}
            loading="lazy"
            className="card-image"
          />
        )}
        {aScrimGradient && <AScrimGradient {...aScrimGradient} />}
      </Styled.ImageContainer>

      <Styled.ContentOverlay>
        {aIcon && (
          <Styled.IconWrapper>
            <AIcon icon={aIcon.icon} size={aIcon.size} />
          </Styled.IconWrapper>
        )}

        {mTag && mTag.aLabel && (
          <Styled.TagWrapper>
            <MTag
              type={mTag.type}
              aLabel={{
                text: mTag.aLabel.text || '',
                size: mTag.aLabel.size as ALabelSize,
              }}
            />
          </Styled.TagWrapper>
        )}

        {mTextBlockBasic && (
          <Styled.TextBlockWrapper>
            <MTextBlockBasic
              alignment={mTextBlockBasic.alignment}
              aEyebrow={mTextBlockBasic.aEyebrow}
              aSubheader={
                mTextBlockBasic.aSubheader?.text
                  ? {
                      text: mTextBlockBasic.aSubheader.text,
                      size: mTextBlockBasic.aSubheader.size,
                    }
                  : undefined
              }
              aBody={
                mTextBlockBasic.aBody?.bodyText
                  ? {
                      bodyText: mTextBlockBasic.aBody.bodyText,
                      size: mTextBlockBasic.aBody.size,
                      color: mTextBlockBasic.aBody.color,
                    }
                  : undefined
              }
            />
          </Styled.TextBlockWrapper>
        )}

        {showButton1 && (
          <Styled.ButtonWrapper>
            <MButton
              variant={mButton.type as MButtonType}
              size={mButton.size as MButtonSize}
              href={ctaLink}
              isExternal={mButton.externalLink}
              iconPlacement={mButton.icon ? (mButton.icon as MButtonIconPlacement) : undefined}
            >
              {mButton.buttonText}
            </MButton>
          </Styled.ButtonWrapper>
        )}

        {showIconButton && mButtonIcon && (
          <Styled.IconButtonWrapper>
            <MButton
              variant={MButtonType.Tertiary}
              size={MButtonSize.M}
              href={ctaLink}
              iconPlacement={MButtonIconPlacement.Trailing}
              iconClass={mButtonIcon.aIcon?.icon}
            >
              {' '}
            </MButton>
          </Styled.IconButtonWrapper>
        )}
      </Styled.ContentOverlay>
    </Styled.Wrapper>
  );
};

export * from './OCardLayeredStandard.types';
